import axios from 'axios'

/**
 * Requests made with responseType 'blob' receive their *error* bodies as Blobs
 * too, which hides the API's JSON error payload from getApiErrorMessage.
 * Re-hydrate JSON blobs into plain objects so error messages surface normally.
 */
export async function parseBlobErrorData(error: unknown): Promise<void> {
  if (!axios.isAxiosError(error)) return
  const data = error.response?.data
  if (error.response && data instanceof Blob && data.type.includes('json')) {
    try {
      error.response.data = JSON.parse(await data.text())
    } catch {
      // Unparseable body - keep the Blob and fall back to the generic message.
    }
  }
}
